module.exports = __webpack_public_path__ + "static/outlook_web_1-8c06837fec2d7d5aa4c9e4e86a0e5bc1.png";